import "./ColourPickerDialogComponent.scss";
import Colours from "./Colours";
import {IOnInit} from "angular";

export const TfColourPicker = "tfColourPickerDialog";

export function tfColourPickerDialog() {
    return {
        templateUrl: "app/components/colour-picker/dialog/ColourPickerDialogComponent.html",
        bindings: {
            data: "<"
        },
        controller: ColourPickerDialogComponentController,
        controllerAs: "ctrl"
    };
}

export class ColourPickerDialogComponentController implements IOnInit {

    public availableColours: Array<string> = [];
    public defaultColour: string;

    /** @ngInject */
    public constructor(private data: ColourPickerDialogData) {
        this.defaultColour = this.data.defaultColour || "#000000";
    }

    public $onInit() {
        this.availableColours = Colours.reduce((acc, row) => acc.concat(row), []);
    }
}

export interface ColourPickerDialogData {
    selectedColour?: string;
    defaultColour?: string;
}
